import React from "react";
import ContentLoader from "react-content-loader";

export default function Loading() {
  return (
    <ContentLoader
      height={220}
      width={300}
      speed={2}
      primaryColor="#b2b2b2"
      secondaryColor="#ecebeb"
    >
      <rect x="0" y="0" rx="10" ry="10" width="290" height="185" />
    </ContentLoader>
  );
}
